import { ScatterPlotStatus } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// Services
import { YChartsScatterPlotService } from 'ChartApp/ts/services/ycharts-scatter-plot-service/ycharts-scatter-plot.service';
import * as i0 from "@angular/core";
/**
 * Scatter Plot Base Directive
 *
 * This class contains common code for components that fetch scatter plot data and display a scatter plot.
 */
export class ScatterPlotBaseDirective {
    constructor() {
        this.status = ScatterPlotStatus.getStarted;
        // Errors
        // Find codes where ScatterPlotException is raised in the backend
        this.backendErrorCodes = new Set(['securities', 'metrics']);
        this.error = { code: '', message: '' };
        // Services
        this.ychartsScatterPlotService = new YChartsScatterPlotService();
        // Subscriptions
        this.axisExtremesSubscription = null;
        this.fetchSubscription = null;
    }
    ngOnDestroy() {
        if (this.axisExtremesSubscription !== null) {
            this.axisExtremesSubscription.unsubscribe();
        }
        if (this.fetchSubscription !== null) {
            this.fetchSubscription.unsubscribe();
        }
    }
}
ScatterPlotBaseDirective.ɵfac = function ScatterPlotBaseDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotBaseDirective)(); };
ScatterPlotBaseDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ScatterPlotBaseDirective });
